import {Component} from "./Component";
import {createElement} from "../util/html";
import gsap from "gsap";

export class Toast extends Component {
    static name = "toast";

    static currentToast;

    get name() {
        return Toast.name;
    }

    constructor(el) {
        super(el);
        Toast.instance = this;

    }

    /**
     * Hides toast and removes it from dom or does nothing if no element was passed and no currentToast exists
     * @param {HTMLElement} [el] The toast element to hide, defaults to currentToast if none is passed
     */
    static hideToast(el) {
        el = el || Toast.currentToast;
        gsap.to(el, {
            y: "+=100%",
            onComplete: () => el.remove(),
            duration: 0.2,
            ease: "back.in(1.3)",
        });
    }

    /**
     * Shows toast
     *
     * @param {string} message Toast message
     * @param {"success"|"error"} [type] Type of toast, can be error or success. Defaults to success
     * @param {number} [duration] Duration toast is visible for in ms or 0 to not hide automatically, defaults to 0
     */
    static showToast(message, type = "success", duration = 0) {
        console.log("showToast", {duration});
        if (Toast.currentToast) {
            Toast.hideToast(Toast.currentToast);
        }

        const toast = createElement(`<div class="toast toast--${type}">
            <div class="toast__inner">
                <p class="toast__text">
                    ${message}
                </p>
                <button class="toast__close">
                    <span class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <rect x="5.41418" y="4.14209" width="20" height="2" rx="1" transform="rotate(45 5.41418 4.14209)" fill="currentColor"/>
                            <rect x="10.7781" y="11.7781" width="11" height="2" rx="1" transform="rotate(-45 10.7781 11.7781)" fill="currentColor"/>
                            <rect x="4.41418" y="18.1421" width="11" height="2" rx="1" transform="rotate(-45 4.41418 18.1421)" fill="currentColor"/>
                        </svg>
                    </span>
                </button>
            </div>
        </div>`);

        const close = Toast.hideToast.bind(null, toast);

        toast.querySelector(".toast__close").addEventListener("click", close);

        gsap.set(toast, {
            y: "+=100%",
        });

        document.body.append(toast);

        gsap.to(toast, {
            y: 0,
            duration: 0.3,
            ease: "back.out(1.3)",
        });

        Toast.currentToast = toast;

        if (duration) setTimeout(close, duration);
    }


}
